<template>
  <div>
    <Button type="primary" @click="handleAdd()">新建</Button>
    <div class="content">
      <el-table
          border
        :data="tableData"
        style="width: 100%">
        <!-- <el-table-column type="selection" width="55" prop=""></el-table-column> -->
<!--        <el-table-column prop="account" label="账户" width="150"></el-table-column>-->
        <el-table-column prop="certificateTypeVo.name" label="姓名" width="150"></el-table-column>
        <el-table-column prop="sex" label="性别" width="120">
          <template slot-scope="{ row }">
            <span v-if="row.sex === 1">男</span>
            <span v-else-if="row.sex === 2">女</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column prop="nativePlace" label="籍贯" width="120"></el-table-column>
        <el-table-column prop="ethnic" label="民族" width="120"></el-table-column>
        <el-table-column prop="birthday" label="出生年月" width="200">
          <template slot-scope="{ row }">
            {{ row.birthday | timeFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="certificateType" label="证件类型" width="200">
          <template slot-scope="{ row }">
            {{ row.certificateType | fliterZj(documentTypeList) }}
          </template>
        </el-table-column>
        <el-table-column label="照片" width="200">
          <template slot-scope="{ row }">
            <el-avatar size="medium" :src="host + row.certificatePicture"></el-avatar>
          </template>
        </el-table-column>
        <el-table-column prop="idNumber" label="证件号码" width="250"></el-table-column>
        <el-table-column prop="education" label="最高学历" width="200">
          <template slot-scope="{ row }">
            {{ row.education | xlFilter(educationList) }}
          </template>
        </el-table-column>
        <el-table-column prop="mobileTelephone" label="移动电话" width="200"></el-table-column>
        <el-table-column prop="emailAddress" label="电子邮箱" width="250"></el-table-column>
        <el-table-column prop="hiredate" label="进入本单位日期" width="200">
          <template slot-scope="{ row }">
            {{ row.hiredate | timeFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="workingYears" label="工龄" width="150"></el-table-column>
        <el-table-column prop="certificateTypeId" label="资格证书类型" width="200">
          <template slot-scope="{ row }">
            {{ getType(row.certificateTypeId) }}
          </template>
        </el-table-column>
        <el-table-column prop="certificateNo" label="证书编号" width="200"></el-table-column>
        <el-table-column prop="effectiveDateStart" label="证书有效期起" width="200">
          <template slot-scope="{ row }">
            {{ row.effectiveDateStart | timeFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="effectiveDateEnd" label="证书有效期止" width="200">
          <template slot-scope="{ row }">
            {{ row.effectiveDateEnd | timeFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" width="200"></el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button @click="handleEdit(row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelete(row)" type="text" style="color: red" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: right">
        <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { responsiblePersonsList, responsiblePersonsDelete, getWorkType } from "@/api/processManager"
export default {
  name: 'ProcessPersonCharge',
  data() {
    return {
      tableData: [],
      total: 0,
      pageSize: 10,
      curPage: 1,
      documentTypeList: [
        { id: 1, name: '居民身份证' },
        { id: 2, name: '军人证' },
        { id: 3, name: '港澳台居民身份证' },
        { id: 4, name: '华侨身份证' },
        { id: 5, name: '外籍护照' },
        { id: 6, name: '其他' }
      ],
      educationList: [
        {id: 1, name: '小学'},
        {id: 2, name: '初中'},
        {id: 3, name: '高中'},
        {id: 4, name: '大专'},
        {id: 5, name: '本科'},
        {id: 6, name: '研究生'},
        {id: 7, name: '硕士'},
        {id: 8, name: '博士'},
        {id: 9, name: '博士后'},
      ],
      // 资格证书的数组
      options: []
    }
  },
  filters: {
    timeFilter(time) {
      if (time) {
        return time.split(' ')[0]
      } else {
        return ''
      }
    },
    fliterZj(type, arr) {
      for(let i in arr) {
        if(arr[i].id === type) {
          return arr[i].name
        }
      }
    },
    xlFilter(id,arr){
      for (let i in arr){
        if (arr[i].id === id){
          return arr[i].name
        }
      }
    }
  },
  async created() {
    await this.getWorkType();
    this.getTableData();
  },
  methods: {
    // 获取表格数据
    getTableData() {
      responsiblePersonsList({ limit: this.pageSize, curPage: this.curPage }).then(res => {
        this.tableData = res.body.data;
      })
    },
    // 获取资格证类型
    async getWorkType() {
      await getWorkType({ type: 2 }).then(res => {
       this.options = res.body.data[0].childList;
      })
    },
    // 表格中通过id回显类型
    getType(id) {
      for(let i in this.options) {
        if(this.options[i].id === id) {
          return this.options[i].name
        }
      }
    },
    // 页码改变
    pageChange(val) {
      this.curPage = val;
      this.getTableData();
    },
    // 新增
    handleAdd() {
      this.$router.push('AddPersonCharge');
    },
    // 编辑
    handleEdit(row) {
      let obj = { ...row }
      for(let i in obj) {
        if(obj[i] === null) {
          delete obj[i]
        }
      }
      this.$router.push({
        name: 'AddPersonCharge',
        params: { key: obj }
      })
    },
    // 删除
    handleDelete(row) {
      this.$confirm(`删除主要负责人 “${row.name}” 的信息, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        responsiblePersonsDelete(row.id).then(res => {
          this.$message.success('删除成功');
          this.getTableData();
        })
      }).catch(() => {
        return
      });
    }
  }
}
</script>

<style scope>
.head {
  width: calc(100% - 280px)
}
</style>
